import type { ButtonProps } from "@chakra-ui/react";

/** Shared trigger styles for queue/notification icons inside the sidebar rail. */
export const sidebarUtilityTriggerProps: Pick<ButtonProps, "color" | "_hover"> =
  {
    color: "themeColor.utility.fg",
    _hover: {
      bg: "themeColor.utility.hoverBg",
      color: "themeColor.utility.hoverFg",
    },
  };

/** Fallback when sidebar semantic scope is not applied. */
export const defaultUtilityTriggerProps: Pick<ButtonProps, "color" | "_hover"> =
  {
    color: "neutral.400",
    _hover: {
      bg: "neutral.50",
      color: "neutral.700",
    },
  };
